import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import Icon from "../Icons/Icon";

import "./BottomNavigation.scss";

// Place label text inside span tags if needed
class BottomNavigation extends React.Component {
  constructor(props) {
    super(props);

    this.URL_MAPPING = this.props.isMerchant
      ? {
          one: "/dropoff",
          two: "/home",
          three: "/pickup"
        }
      : {
          one: "/packages/ready",
          two: "/lockers",
          three: "/account"
        };

    this.state = {
      checked: this.getIdFromUrl(this.props.location.pathname)
    };
  }

  componentWillReceiveProps(nextProps) {
    // handle URL change
    if (this.props.location.pathname !== nextProps.location.pathName) {
      this.setState({
        checked: this.getIdFromUrl(nextProps.location.pathname)
      });
    }
  }

  getIdFromUrl = url => {
    for (const key of Object.keys(this.URL_MAPPING)) {
      if (this.URL_MAPPING[key] === url) return key;
    }
    return this.props.isMerchant ? "two" : "one";
  };

  handleButtonClick = event => {
    const id = event.currentTarget.id;
    this.setState({ checked: id });
    this.props.history.push(`${this.URL_MAPPING[id]}`);
  };

  render() {
    const { isMerchant } = this.props;

    return (
      <nav className="menu">
        <input
          type="radio"
          name="menu"
          id="one"
          checked={this.state.checked === "one"}
          onClick={this.handleButtonClick}
          readOnly
        />
        <input
          type="radio"
          name="menu"
          id="two"
          checked={this.state.checked === "two"}
          onClick={this.handleButtonClick}
          readOnly
        />
        <input
          type="radio"
          name="menu"
          id="three"
          checked={this.state.checked === "three"}
          onClick={this.handleButtonClick}
          readOnly
        />
        <div className="list">
          <div className="link-wrap">
            <label htmlFor="one">
              <Icon type="box" checked={this.state.checked === "one"} />
              <span>{isMerchant ? "Drop Off" : "Packages"}</span>
            </label>
            <label htmlFor="two">
              <Icon type="map" checked={this.state.checked === "two"} />
              <span>{isMerchant ? "Home" : "Lockers"}</span>
            </label>
            <label htmlFor="three">
              <Icon type="user" checked={this.state.checked === "three"} />
              <span>{isMerchant ? "Pick Up" : "Account"}</span>
            </label>
          </div>
        </div>
      </nav>
    );
  }
}

BottomNavigation.propTypes = {
  isMerchant: PropTypes.bool
};

export default withRouter(BottomNavigation);
